export default __webpack_public_path__ + "static/media/android-icon-192x192.0d7efdc9.png";